<script lang="ts" setup>
// Components
import HeaderOverview from '../components/header.vue';
import CardObjectives from '../components/card/objectives.vue';
import CardWeekly from '../components/card/weekly.vue';
import CardContactUs from '../components/card/contactUs.vue';
</script>
<template>
  <ui-page :title="$t('global.overview')">
    <div>
      <header-overview />

      <div class="grid grid-cols-2 mt-6 gap-4">
        <card-objectives />
        <div class="grid grid-cols-1 gap-4">
          <card-weekly />
          <card-contact-us />
        </div>
      </div>
    </div>
  </ui-page>
</template>
